/**
 * Image Services.
 *
 * This file houses any DOM manipulation of images like lazy loading.
 * @format
 */
import { safeCurrentLanguage } from './drupal-services';

/**
 * Localize Images.
 */
const localizeImages = () => {
  const localImages: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.localized-image, .localized-background'
  );

  if (localImages.length > 0) {
    localImages.forEach((image) => {
      // Convert hyphen data string to camel case.
      const localImage = `local-image-${safeCurrentLanguage()}`.replace(
        /-([a-z])/g,
        function (g) {
          return g[1].toUpperCase();
        }
      );

      if (image.dataset[localImage]) {
        if (image.classList.contains('localized-background')) {
          image.style.backgroundImage = `url(${image.dataset[localImage]})`;
          image.dataset.backgroundImage = image.dataset[localImage];
        } else if (image.classList.contains('localized-image')) {
          image.dataset.src = image.dataset[localImage];
        }
      }
    });
  }
};

/**
 * Returns original or a formatted url for the image.
 */
export const getWidenImageUrl = (imageId: string) => {
  return imageId.startsWith('http')
    ? imageId
    : `https://varian.widen.net/content/${imageId}/webp`;
};

/**
 * Get Image Aspect Ratio.
 */
export const getImageAspectRatio = async (widenImageUrl: string) => {
  let imageData = {};
  if (widenImageUrl) {
    const image = new Image();
    image.src = widenImageUrl;
    await image
      .decode()
      .then(() => {
        imageData = {
          aspectRatio: image.naturalHeight / image.naturalWidth,
          height: image.naturalHeight,
          width: image.naturalWidth,
        };
        // console.log(imageData);
      })
      .catch((error) => {
        console.warn(error);
      });
  }
  return imageData;
};

/**
 * Load Image Servies.
 */
export const loadImageServices = (): void => {
  localizeImages();
};
